// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".kevin[data-v-3bdd757a]{width:200px;height:auto}h1[data-v-3bdd757a],h2[data-v-3bdd757a],h3[data-v-3bdd757a]{margin:0;font-weight:400}h1[data-v-3bdd757a],h2[data-v-3bdd757a]{font-size:7vmin!important}h3[data-v-3bdd757a]{font-size:5vmin!important}.bottom-border[data-v-3bdd757a]{display:inline-block;padding-bottom:20px;border-bottom:6px solid #f26721;margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
